// @flow

import React from "react";
import { Modal, ModalContent, ModalHeader, Text } from "@unifize/sarah";
import { SettingsPlaceholder } from "src/components/Unifize";
import AdHocDetails from "./AdHocDetails";
import CreatorDetails from "./CreatorDetails";

import type {
  RevisionFieldSettingsv2,
  ApprovalFieldSettingsV2,
  RoomId,
  FieldId,
} from "src/types";

type Props = {
  isOpen: boolean,
  onClose: Function,
  title: string,
  subtitle?: string,
  emptySubtitle?: string,
  path: string,
  settings: RevisionFieldSettingsv2 | ApprovalFieldSettingsV2,
  roomId: RoomId,
  fieldId: FieldId,
};

const CreatorsModal = ({
  isOpen,
  onClose,
  settings,
  title,
  subtitle = "",
  emptySubtitle = "",
  path,
  fieldId,
  roomId,
}: Props) => {
  const { requiredApprovers = "some" } = settings;
  const isAdHoc = requiredApprovers === "adhoc";
  const { [path]: value = {} } = settings;
  const {
    groups = [],
    roles = [],
    users = [],
    fields = [],
    allParticipants,
    owner,
  } = value;
  const isEmpty = !(
    groups?.length ||
    roles?.length ||
    users?.length ||
    fields?.length ||
    allParticipants ||
    owner
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} position="center" height="auto">
      <ModalHeader>{title}</ModalHeader>
      <ModalContent>
        {subtitle && (
          <Text
            variant="body"
            weight="regular"
            style={{ marginBottom: "12px" }}
          >
            {isEmpty && emptySubtitle ? emptySubtitle : subtitle}
          </Text>
        )}
        {isEmpty ? (
          <SettingsPlaceholder />
        ) : isAdHoc ? (
          <AdHocDetails
            fieldId={fieldId}
            roomId={roomId}
            settings={settings}
            path={path}
          />
        ) : (
          <CreatorDetails path={path} settings={settings} />
        )}
      </ModalContent>
    </Modal>
  );
};

export default CreatorsModal;
